module.exports = __webpack_public_path__ + "static/media/cubits.454135f3.png";